"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useCallback, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
export function NavigationProgress() {
  const $ = _c(15);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [isNavigating, setIsNavigating] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressIntervalRef = useRef(null);
  const previousPathRef = useRef(pathname + searchParams.toString());
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsNavigating(true);
      setProgress(0);
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
      }
      let currentProgress = 0;
      progressIntervalRef.current = setInterval(() => {
        currentProgress = currentProgress + Math.random() * 15;
        currentProgress;
        if (currentProgress > 90) {
          currentProgress = 90;
          if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
          }
        }
        setProgress(currentProgress);
      }, 200);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const startProgress = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
      }
      setProgress(100);
      setTimeout(() => {
        setIsNavigating(false);
        setProgress(0);
      }, 200);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const completeProgress = t1;
  let t2;
  let t3;
  if ($[2] !== pathname || $[3] !== searchParams) {
    t2 = () => {
      const currentPath = pathname + searchParams.toString();
      if (previousPathRef.current !== currentPath) {
        completeProgress();
        previousPathRef.current = currentPath;
      }
    };
    t3 = [pathname, searchParams, completeProgress];
    $[2] = pathname;
    $[3] = searchParams;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== pathname || $[7] !== searchParams) {
    t4 = () => {
      const handleClick = e => {
        const target = e.target as HTMLElement;
        const link = target.closest("a");
        if (link) {
          const href = link.getAttribute("href");
          const target_0 = link.getAttribute("target");
          if (href && !target_0 && href.startsWith("/") && !href.startsWith("//")) {
            const currentPath_0 = pathname + searchParams.toString();
            if (href !== currentPath_0 && !href.startsWith("#")) {
              startProgress();
            }
          }
        }
      };
      document.addEventListener("click", handleClick, true);
      return () => document.removeEventListener("click", handleClick, true);
    };
    t5 = [pathname, searchParams, startProgress];
    $[6] = pathname;
    $[7] = searchParams;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => () => {
      if (progressIntervalRef.current) {
        clearInterval(progressIntervalRef.current);
      }
    };
    t7 = [];
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  if (!isNavigating && progress === 0) {
    return null;
  }
  const t8 = `${progress}%`;
  const t9 = isNavigating ? "0 0 10px rgba(251, 146, 60, 0.5), 0 0 5px rgba(251, 146, 60, 0.3)" : "none";
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <div className="fixed top-0 left-0 right-0 z-[9999] h-1 bg-transparent"><div className="h-full bg-gradient-to-r from-amber-500 to-orange-500 transition-all duration-200 ease-out" style={{
        width: t8,
        boxShadow: t9
      }} /></div>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}